import { PermissionCode, ProductCode } from '@gb-ticket/shared-types';
import { LayoutDashboardIcon } from 'lucide-react';

import { hasPermission } from '@/platform/auth/permissions';
import { useMe } from '@/platform/auth/use-me';
import { ProductSideNav } from '@/platform/components/product-side-nav';
import { registerProductNav } from '@/platform/lib/product-nav';
import {
  ONBOARDING_CASES_PATH,
  ONBOARDING_ROOT,
  ONBOARDING_TEMPLATES_PATH,
} from '@/products/onboarding/onboarding-paths';

function canReadOnboardingCases(user: Parameters<typeof hasPermission>[0]): boolean {
  return (
    hasPermission(user, PermissionCode.ONBOARDING_CASES_READ) ||
    hasPermission(user, PermissionCode.ONBOARDING_CASES_MANAGE)
  );
}

function OnboardingNav() {
  const me = useMe();
  const templatesManage = hasPermission(me.data, PermissionCode.ONBOARDING_TEMPLATES_MANAGE);
  const casesReadOrManage = canReadOnboardingCases(me.data);

  return (
    <ProductSideNav
      ariaLabel="Eintritt und Austritt"
      items={[
        {
          to: ONBOARDING_ROOT,
          label: 'Übersicht',
          end: true,
          icon: <LayoutDashboardIcon aria-hidden className="size-4" strokeWidth={1.75} />,
        },
        ...(casesReadOrManage ? [{ to: ONBOARDING_CASES_PATH, label: 'Vorgänge' }] : []),
        ...(templatesManage ? [{ to: ONBOARDING_TEMPLATES_PATH, label: 'Vorlagen' }] : []),
      ]}
    />
  );
}

registerProductNav({
  code: ProductCode.ONBOARDING,
  Nav: OnboardingNav,
  menuTiles: [
    { id: 'onboarding-home', label: 'Übersicht', to: ONBOARDING_ROOT },
    {
      id: 'onboarding-cases',
      label: 'Vorgänge',
      to: ONBOARDING_CASES_PATH,
      isVisible: canReadOnboardingCases,
    },
    {
      id: 'onboarding-templates',
      label: 'Vorlagen',
      to: ONBOARDING_TEMPLATES_PATH,
      isVisible: (user) => hasPermission(user, PermissionCode.ONBOARDING_TEMPLATES_MANAGE),
    },
  ],
  mobileSlots: [
    { kind: 'link', id: 'onboarding-home', label: 'Übersicht', to: ONBOARDING_ROOT },
    {
      kind: 'link',
      id: 'onboarding-cases',
      label: 'Vorgänge',
      to: ONBOARDING_CASES_PATH,
      isVisible: canReadOnboardingCases,
    },
    {
      kind: 'link',
      id: 'onboarding-templates',
      label: 'Vorlagen',
      to: ONBOARDING_TEMPLATES_PATH,
      isVisible: (user) => hasPermission(user, PermissionCode.ONBOARDING_TEMPLATES_MANAGE),
    },
  ],
});
